import { Button } from 'canoe';
import React from 'react';
import { s3Image } from 'site-constants';

import { useNavigation } from 'commons/hooks';
import EmptyState from 'dashboard/components/EmptyState';
import { CONTENT_PATH } from 'dashboard/pages/Content/constants';
import { PREVIEW_TEMPLATES_ROUTE } from 'dashboard/pages/Content/pages/Templates/constants';

const GoToTemplates = () => {
  const navigate = useNavigation();
  return (
    <Button
      variant="secondary"
      onClick={() => navigate(`${CONTENT_PATH}/${PREVIEW_TEMPLATES_ROUTE.path}`)}
    >
      Go to Templates
    </Button>
  );
};

/** Layout for an empty template page */
const NotFound = () => (
  <EmptyState
    imageURL={s3Image('/svg/tutorial-document-not-found.svg')}
    heading="Template Not Found"
    text="We can't find the Template you're looking for. Choose one from your Templates or create a new one."
    cta={<GoToTemplates />}
  />
);

export default NotFound;
